import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../constants/text';
import { biggerThanOrEqualTo } from '../../../../core/util/styledComponents';
import Hidden from '@material-ui/core/Hidden';
import { getDefaultBreakpoint } from '../../../../core/util/device/screen';
import RecentlyBookedIcon from '../../../../components/SolvPatternLibrary/Icons/RecentlyBooked';
import { RECENTLY_BOOKED, shouldShowFeature } from '../../util/customization';
import { pluralize } from '../../../../core/util/string';

const Root = styled.div`
  padding: 0 5% 12px;
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.blueMonday};
  display: flex;
  align-items: center;
  justify-content: center;

  ${biggerThanOrEqualTo.md`
    padding: 0 5% 20px 5%;
    border-top: ${colors.greyHounds} 1px solid;
    justify-content: space-between;
    font-size: ${fontSize.small};
  `}
`;

const StyledRecentlyBookedIcon = styled(RecentlyBookedIcon)`
  margin-right: 16px;

  ${biggerThanOrEqualTo.md`
    path {
      fill: ${colors.peaches};
    }
  `}
`;

const Copy = styled.div`
  line-height: 18px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const StrongText = styled.span`
  font-family: ${fontFamily.bold};
`;

export default class RecentlyBooked extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    className: PropTypes.string,
  };

  render() {
    const {
      location,
      location: { recentBookings },
      className,
    } = this.props;

    if (!recentBookings || !shouldShowFeature(RECENTLY_BOOKED, location)) {
      return null;
    }

    return (
      <Root className={className}>
        <Hidden initialWidth={getDefaultBreakpoint()} smDown>
          <Copy>
            <StrongText>Popular Clinic!</StrongText>
            <span>
              This clinic has been booked on Solv {recentBookings}{' '}
              {pluralize(recentBookings, 'time')} today
            </span>
          </Copy>
          <StyledRecentlyBookedIcon />
        </Hidden>
        <Hidden initialWidth={getDefaultBreakpoint()} mdUp>
          <StyledRecentlyBookedIcon />
          <Copy>
            <span>{recentBookings} recently booked</span>
          </Copy>
        </Hidden>
      </Root>
    );
  }
}
